export default {
  items: [],
  defaultSort: {
    page: 1,
    column: 'team_name',
    order: 'ascending',
    limit: 0,
  },
  sort: {
    page: 1,
    column: 'team_name',
    order: 'ascending',
    limit: 0,
    filter: '',
  },
  more: true,
  loading: false,
  total: 0,
  updated: null,
  overallCount: 0,
};
